import {PERMISSION_TYPE} from '../../../Permissions';

type Assignee = {permissions?: ReadonlyArray<string | null> | null} | null | undefined;

/**
 * The one definition of a client-owned task: it has assignees, and every one of them is a
 * Forecast client user (a guest created from a client contact, `person.client_id` set).
 * Anything else — unassigned, firm-assigned, or mixed — is firm-owned, because the firm
 * remains accountable for it and firm-owned is the fail-closed reading of the portal
 * visibility rule that firm-owned tasks are read-only to clients.
 *
 * Deliberately not `personIsClientUser`: that throws on a non-array `permissions`, and
 * some task-table fragments do not select the field. An assignee whose permissions are
 * unknown is not proven to be a client, so it counts as firm.
 *
 * The portal PSA feed's `isFirmOwned` should be derived with this same rule once it stops
 * being a constant.
 */
export const isClientOwnedTask = (assignedPersons: ReadonlyArray<Assignee> | null | undefined): boolean =>
	!!assignedPersons &&
	assignedPersons.length > 0 &&
	assignedPersons.every(person => !!person?.permissions?.includes(PERMISSION_TYPE.IS_CLIENT_USER));
